import script from "./LevelRatio.vue?vue&type=script&setup=true&lang=js"
export * from "./LevelRatio.vue?vue&type=script&setup=true&lang=js"

import "./LevelRatio.vue?vue&type=style&index=0&id=5e5ca0cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5ca0cd"]])

export default __exports__